import { render, staticRenderFns } from "./auth-shell.vue?vue&type=template&id=474cd644&scoped=true&"
import script from "./auth-shell.vue?vue&type=script&lang=js&"
export * from "./auth-shell.vue?vue&type=script&lang=js&"
import style0 from "./auth-shell.vue?vue&type=style&index=0&id=474cd644&scoped=true&lang=css&"
import style1 from "./auth-shell.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474cd644",
  null
  
)

export default component.exports